import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "../../../common";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional


type CommonProps = {
    block?: boolean;
    large?: boolean;
    small?: boolean;
    tiny?: boolean;
    disabled?: boolean;
    color?: string;
    active?: boolean;
    name?: string;
    value?: string;
    classNames?: string;
    style?: React.CSSProperties;
};


type buttonProps = CommonProps & {
    textColor?: string;
    bgColor?: string;
    bgHoverColor?: string;
    ringColor?: string;
    to?: string;
    href?: string;
    target?: string;
    Icon?: any;
    children?: React.ReactNode;
    type?: "button" | "submit";
    classes?: Array<string>;
    tooltip?: any;
    onClick?: (
        event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
    ) => void;
}

const Button = ({
    textColor,
    bgColor,
    bgHoverColor,
    ringColor,
    to,
    href,
    Icon,
    children,
    type,
    target,
    disabled,
    name,
    value,
    classes,
    tooltip,
    ...rest }: buttonProps) => {

        //focus:outline-none focus:ring-2 focus:ring-offset-2 focus:${ringColor || 'ring-blue-500'}

    const styles = `${disabled && 'cursor-not-allowed disabled:opacity-50'} px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium ${textColor || 'text-white'} ${bgColor || 'bg-blue-600'} hover:${bgHoverColor || 'bg-blue-700'} ${classes && classNames(classes)} `;

    var c;

    if (disabled) {
        to = undefined;
        href = undefined;
    }

    if (href != null) {
        c = (
            <a
                className={styles}
                href={href}
                {...rest}
                target={target}>
                {children} {Icon && <Icon />}
            </a>
        );
    }

    if (to != null) {
        c = (
            <Link
                className={styles}
                to={to}
                {...rest}>
                {children} {Icon && <Icon />}
            </Link>
        );
    }

    if (!c) {
        c = (
            <button
                className={styles}
                type={type}
                {...rest}
                disabled={disabled}
                name={name}
                value={value}
            >
                {Icon && <Icon />}
                {children}
            </button>
        );
    }

    if (tooltip) {
        return (
            <Tippy content={tooltip} >{c}</Tippy>
        )
    }

return c;
}

export default Button;
